<template>
  <section class="container m-auto h-full container flex justify-center items-center sm:h-full md:h-screen lg:h-screen xl:h-screen">   
    <div class="w-1/2 sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-3/4" v-bind:class="[ error ? 'p-12 border-2 rounded-md border-red-800 bg-red-200' : '']">
    <p v-if="error" class="text-center text-2xl text-red-800 mb-6">{{error}}</p>
      <div class="max-w-full mb-6 text-2xl text-gray-800 leading-8">
        <span class="text-base text-blue-500 leading-7">{{question.prefix}}.</span> 
        {{question.text}}
      </div>
      <p v-if="question.secondaryText" class="text-gray-600">{{question.secondaryText}}</p>
      <div v-if="question.displayType=='radio-button'" class="max-w-full">
        <div class="grid my-10 gap-3" :class="gridColumnsClass">
          <!-- first col with child questions -->
          <div class="col-span-3 grid items-center" :class="gridRowsClass">
            <!-- <div class="row text-right py-3 mr-3 first:row-start-2" v-for="(item, index) in question.items" :key="index"> -->
            <div class="row-start-1 row-span-1 py-1"></div>
            <div class="row text-right py-1 mr-3" v-for="(item, index) in question.items" :key="index">
              {{item.text}}
            </div>
          </div>
          <!-- remaining cols with answer options -->
          <div class="col-span-1 grid" :class="gridRowsClass" v-for="(option,index) in question.answerOptions" :key="index">
            <!-- header with answer text -->
            <div class="text-center align-center">{{option.value.display}}</div> 
            <!-- nested rows for answer input -->
            <div v-for="(answerItem, index) in question.items" :key="index">
              <radio-button v-bind:status="queryStatus(answerItem.linkId, option.value.value)" @toggle="onToggle(answerItem.linkId, option.value.value)"></radio-button>
              <!-- <radio-button :status="false" @ticked="onTicked()"></radio-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import RadioButton from '@/components/RadioButton.vue'

  export default {
    props: ['error', 'index', 'question'],
    data() {
      return {
        answer: {},
      }
    },
    computed: {
      gridColumnsClass () {
        return `grid-cols-${this.question.answerOptions.length + 3}`  // +3 for child questions in spanned col 1
      },
      gridRowsClass () {
        return `grid-rows-${this.question.items.length + 1}` // +1 to allow for answer options header row
      }
    },
    methods: {
      onToggle (childQuestionId, answerValue) {
        // if the ticked answer is already stored, delete it to toggle
        if (this.answer[childQuestionId] && this.answer[childQuestionId] === answerValue) {
          this.$delete(this.answer, childQuestionId)
        } else {
          // if there's already a different answer stored for this question, delete it
          if (this.answer[childQuestionId]) this.$delete(this.answer, childQuestionId)
          
          this.$set(this.answer, childQuestionId, answerValue)
        }
        this.$emit('answered', this.question, this.answer)
      },
      // check if answer has been selected
      queryStatus (childQuestionId, value) {
        if (this.answer[childQuestionId]) return this.answer[childQuestionId] === value 
        else return false
        // return (typeof this.answer[childQuestionId] != "undefined" && this.answer[childQuestionId][value])
      }
    },
    components: {
      RadioButton
    },
  }
</script>